<template>
    <div>
        <b-card no-body class="page-card">
            <b-card-header class="mx-3 px-0 widget-header">
                <div class="title">
                    <i class="fa fa-align-justify mr-2"></i> {{ trans.title }}
                </div>

                <dropdown-months
                    :trans="transMonths"
                    :year-count="5"
                    :year="currentYear"
                    :month="currentMonth"
                    :choose-action="chooseMonth"
                    :loading="loading"
                    :show-buttons="true"
                />

            </b-card-header>
            <b-card-body class="px-0">
                <div class="loading-box" v-if="loading">
                    <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
                </div>

                <div class="d-flex align-items-center justify-content-around w-100" v-if="!loading">
                    <div class="lock-status">
                        <span>
                            <span class="round-bg" :class="lockedStatus()"><i class="fa fa-icon"></i></span>
                        </span>
                        <p class="desc">
                            <b class="text-info">{{ stats.lockStats.locked }}</b> {{ stats.lockStats.all > 99 ? trans.ofMore : trans.of }} <b class="text-info">{{ stats.lockStats.all }}</b>
                            {{ trans.employeesHaveLockedAttendance }}
                        </p>
                    </div>


                    <div class="send-status" v-if="stats.exportState != null">
                        <doughnut-chart
                            v-if="stats.exportState.type == 2 && !stats.exportState.status"
                            :chart-data="getMultiData()"
                            :chart-label="getMultiLabels()"
                            :chart-total="getMultiResultString()"
                            :chart-colors="['#4175f9','#e5e5e5']"
                            :width="125"
                            :height="125"
                        ></doughnut-chart>

                        <div v-if="stats.exportState.type == 1 || stats.exportState.status">
                            <span class="round-bg" :class="(stats.exportState.status ? '' : 'not-sent')">
                                <i class="fal" :class="(stats.exportState.status ? 'fa-check-double' : 'fa-times')"></i>
                            </span>
                        </div>
                        <p class="desc" v-if='stats.exportState.status'>
                            {{ trans.exportSentAt }}: <b class="text-info">{{ stats.exportState.date }}</b>
                        </p>
                        <p class="desc" v-if='!stats.exportState.status'>{{ trans.exportNotSentYet }}</p>

                    </div>

<!--                    <div class="send-status" v-if="stats.exportState == null">
                        <div>
                            <span class="round-bg not-available"><i class="fal fa-ellipsis-h"></i></span>
                        </div>
                        <p class="desc">{{ trans.exportNotAvailable }}</p>
                    </div>-->


                    <div class="chart-status">
                        <doughnut-chart
                            :chart-data="stats.graphData.data"
                            :chart-label="stats.graphData.labels"
                            :chart-total="stats.graphData.total"
                            :chart-colors="stats.graphData.colors"
                            :width="125"
                            :height="125"
                        ></doughnut-chart>
                        <p class="desc">
                            {{ trans.totalHours }}<br>&nbsp;
                        </p>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'statistics',

        props: {
            'trans': {
                type: Object
            },
            'transMonths': {
                type: Object
            },
            'year': {
                type: Number
            },
            'month': {
                type: Number
            },
        },

        created() {
            this.loadData();
        },

        data() {
            let statsDefaultGraphData = {
                    labels: [''],
                    data: [1],
                    colors: ['#EFEFEF'],
                    total: '0h.'
                };
            let statsDefaultLockStatsData = {
                    all: 0,
                    locked: 0
                };

            return {
                loading: false,
                currentYear: this.year,
                currentMonth: this.month,

                statsDefaultGraphData: statsDefaultGraphData,
                statsDefaultLockStatsData: statsDefaultLockStatsData,

                stats: {
                    lockStats: statsDefaultLockStatsData,
                    graphData: statsDefaultGraphData,
                    exportState: {
                        'type': 1, // 1 = single; 2 = multiple
                        'status': false,
                        'date': null,
                        'restaurantsSent': [],
                        'restaurantsNotSent': []
                    }
                }
            };
        },

        methods: {

            chooseMonth(year, month) {
                this.currentMonth = month;
                this.currentYear = year;

                this.loadData();
            },

            loadData() {
                this.loading = true;
                var _this = this;

                axios.get("/dashboard/stats/"+this.currentYear+"-"+this.currentMonth).then(function (response) {
                    if(response && response.data)
                    {
                        _this.stats.lockStats = (response.data.lockStats) ? response.data.lockStats : _this.statsDefaultLockStatsData;
                        _this.stats.exportState = (response.data.exportState) ? response.data.exportState : null;
                        _this.stats.graphData = (response.data.graphData && response.data.graphData.total_raw > 0) ? response.data.graphData : _this.statsDefaultGraphData;

                        _this.loading = false;
                    }
                }, function (error) {
                    _this.$notify({
                      type: 'error',
                      title: 'Error!',
                      text: typeof error.response !== "undefined" && typeof error.response.data !== "undefined" && error.response.data.message ? error.response.data.message : 'An error has occured.'
                    });

                    _this.loading = false;
                });
            },

            lockedStatus()
            {
                return (this.stats.lockStats.all > 0 && this.stats.lockStats.locked === this.stats.lockStats.all  ? 'closed' : 'not-closed');
            },

            getMultiResultString()
            {
                let countSent = this.stats.exportState.restaurantsSent.length;
                let countNotSent = this.stats.exportState.restaurantsNotSent.length;

                return countSent +" / "+ (countSent+countNotSent);
            },

            getMultiData()
            {
                return [
                    this.stats.exportState.restaurantsSent.length,
                    this.stats.exportState.restaurantsNotSent.length
                ];
            },

            getMultiLabels()
            {
                let restaurantsSent = [this.trans.labelRestaurantsSent];
                for(var x in this.stats.exportState.restaurantsSent)
                {
                    restaurantsSent.push(this.stats.exportState.restaurantsSent[x].title);
                }

                let restaurantsNotSent = [this.trans.labelRestaurantsNotSent];
                for(var x in this.stats.exportState.restaurantsNotSent)
                {
                    restaurantsNotSent.push(this.stats.exportState.restaurantsNotSent[x].title);
                }

                return [
                    restaurantsSent,
                    restaurantsNotSent
                ];
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/dashboard/widgets/Statistics.vue